<template>
  <div class="inspirations-navigation" :class="{ 'inspirations-navigation--footer': footer }">
    <a :href="goToBackLink" class="back-button" @click.prevent.stop="showNavigationConfirmation = true">
      <img src="@/assets/images/icons/home_icon.svg" alt="" />
      <span>Zaprojektuj inny pokój</span>
    </a>

    <teleport v-if="showNavigationConfirmation" to="body">
      <popup classes="main-modal inspirations-modal" @close="showNavigationConfirmation = false">
        <div class="inspirations-confirmation" role="dialog" aria-modal="true" aria-labelledby="inspirations-confirmation-title">
          <div id="inspirations-confirmation-title" class="secondary-title">
            Czy na pewno chcesz wrócić na stronę główną<br />
            i porzucić niezapisane zmiany?
          </div>
          <div class="inspirations-confirmation-buttons d-flex justify-space-between">
            <button class="btn-link transparent-btn" @click.stop="showNavigationConfirmation = false">
              Anuluj
            </button>
            <button class="button-action" @click.stop="goToInspirations">
              Wróć na stronę główną
            </button>
          </div>
        </div>
      </popup>
    </teleport>
  </div>
</template>

<script>
import Popup from '@/components/Popup.vue'

export default {
  name: 'InspirationsNavigation',
  components: {
    Popup,
  },
  props: {
    footer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showNavigationConfirmation: false,
    }
  },
  computed: {
    isTablet() {
      return this.$store.getters['isTablet']
    },
    storeNumber() {
      return this.$store.getters['storeNumber']
    },
    goToBackLink() {
      const url = new URL(this.isTablet
        ? 'https://inspiracje.castorama.pl/kiosk/'
        : 'https://inspiracje.castorama.pl/')

      if (this.isTablet && this.storeNumber) {
        url.searchParams.set('store', this.storeNumber)
      }

      return url.href
    },
  },
  methods: {
    goToInspirations() {
      window.location.href = this.goToBackLink
    },
  },
}
</script>

<style lang="scss" scoped>
.back-button {
  position: absolute;
  bottom: 2rem;
  left: 3rem;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Good-Home-Bold';
  font-size: $font-size-17;
  padding: 0.8rem 1.2rem;
  background: $white;
  color: #434345;
  text-decoration: none;

  img {
    width: 2.5rem;
    margin-right: 0.5rem;
  }

  span {
    margin-top: 0.5rem;
  }
}

.inspirations-confirmation {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  gap: 6.5rem;

  .secondary-title {
    text-align: center;
    line-height: 1.2;
  }
}

.inspirations-confirmation-buttons {
  flex-wrap: wrap;
  align-items: center;
  gap: 2rem;

  button {
    flex: 1;
    max-width: none;
    padding: 0.8rem 2rem;
    min-height: 4.2rem;
  }
}

.inspirations-navigation--footer {
  position: absolute;
  left: 2.2rem;
  max-width: calc(50% - 8rem);

  .back-button {
    position: static;
    justify-content: flex-start;
    padding: 0;
    background: transparent;
    color: $white;
    font-size: $xs-font-size;

    img {
      width: 1.5rem;
      filter: brightness(0) invert(1);
    }

    span {
      margin-top: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
